import React from 'react'
import { Box, Skeleton, Paper } from '@mui/material'
import { StyledPaperStyle } from '@/components/common/styled'

export const HealthHistoryItemSkeleton = () => (
  <Paper sx={{ ...StyledPaperStyle, mb: 2 }}>
    <Box
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      sx={{ cursor: 'pointer' }}
    >
      <Box display='flex' alignItems='center' gap={2}>
        <Skeleton variant='text' width={180} height={28} />
      </Box>
      <Skeleton variant='circular' width={20} height={20} />
    </Box>
  </Paper>
)

export const HealthHistorySkeleton = ({ count = 6 }) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <HealthHistoryItemSkeleton key={`health-history-skeleton-${index}`} />
    ))}
  </>
)

export default HealthHistorySkeleton
